import moment from "moment";
import { amountFormat } from "../../../../services/common.service";
import { Empty, Table } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { selectedAccountSelector } from "../../../../store/selectors/app.selector";

export default function DepositStatementGrid({
  dataSource=[]
}) {
  const { t } = useTranslation();
  const selectedAccount = useSelector(selectedAccountSelector);
  return (
    <>
     <Table
        dataSource={dataSource}
        rowClassName={(record, index) =>
          index % 2 === 0 ? "table-row-light" : "table-row-dark"
        }
        tableLayout="fixed"
        pagination={{
          defaultPageSize: 10,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "30", "40", "50", "100", "500"],
          showTotal: (total, range) =>
            `${range[0]}-${range[1]} of ${total} records`,
        }}
        bordered
        sticky={true}
        onRow={(record) => ({
          // onClick: () => {
          //   console.log(record);
          //   setDetails(record);
          //   setVisible(true);
          // },
        })}
        columns={[
          {
            title: "Trans Date",
            key: "txnDate",
            width: 150,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {moment(option.txnDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "Value Date",
            key: "txnValuedDate",
            width: 150,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {moment(option.txnValuedDate).format("DD-MM-YYYY")}
                </span>
              </>
            ),
          },
          {
            title: "Reference Number",
            key: "refNo",
            width: 200,
            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>{option?.refNo}</span>
              </>
            ),
          },
          {
            title: "Description",
            key: "narration",
            ellipsis: true,

            render: (option) => (
              <>
                <span style={{ fontSize: "13px" }}>
                  {option?.narration || option?.txnTypeDesc}
                </span>
              </>
            ),
          },
          {
            title: `Debit (${selectedAccount?.accountCurrency})`, // "Debit (ZMW)",
            key: "debit",
            align: "right",
            width: 130,
            render: (option) => (
              <span
                style={{ fontSize: "13px" }}
                className={
                  option?.debitOrCredit === "Debit" ? "debit" : "credit"
                }
              >
                {option.debitOrCredit === "Debit" &&
                  amountFormat(option.amount || "", "")}
              </span>
            ),
          },

          {
            title: `Credit (${selectedAccount?.accountCurrency})`, // "Credit (ZMW)",
            key: "credit",
            align: "right",
            width: 130,
            render: (option) => (
              <span
                style={{ fontSize: "13px" }}
                className={
                  option?.debitOrCredit === "Credit" ? "credit" : "debit"
                }
              >
                {option.debitOrCredit === "Credit" &&
                  amountFormat(option.amount || "", "")}
              </span>
            ),
          },
          {
            title: "Balance",
            key: "balance",
            align: "right",
            width: 200,
            render: (option) => (
              <span style={{ fontSize: "13px", fontFamily: "poppinMedium" }}>
                {amountFormat(option?.balance, option.txnCcy)}
              </span>
            ),
          },
        ]}
      />
    </>
  );
}
